import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { defineComponent, watch, h } from '@vue/composition-api';
import CloseV1Outlined from '@kibt/meta-ui-icons/es/icons/CloseV1Outlined';
import Button from '../button/index.js';
import { withInstall } from '../util/index.js';
import { Config } from '../config/index.js';

var lockScrollCount = 0;
var dialogProps = {
  visible: {
    type: Boolean,
    "default": false
  },
  title: {
    type: String,
    "default": null
  },
  content: {
    type: [String, Object],
    "default": null
  },
  // 是否展示关闭icon
  showClose: {
    type: Boolean,
    "default": false
  },
  dialogClass: {
    type: String,
    "default": ''
  },
  mask: {
    type: Boolean,
    "default": true
  },
  maskClosable: {
    type: Boolean,
    "default": true
  },
  maskClass: {
    type: String,
    "default": ''
  },
  showOk: {
    type: Boolean,
    "default": true
  },
  lockScroll: {
    type: Boolean,
    "default": true
  },
  okText: {
    type: String,
    "default": null
  },
  okButtonProps: {
    type: Object,
    "default": function _default() {
      return {
        type: 'primary',
        block: true
      };
    }
  },
  showCancel: {
    type: Boolean,
    "default": true
  },
  cancelText: {
    type: String,
    "default": null
  },
  cancelButtonProps: {
    type: Object,
    "default": function _default() {
      return {
        type: 'default',
        block: true
      };
    }
  },
  buttonDirection: {
    type: String,
    "default": 'horizontal'
  }
};
var Dialog = defineComponent({
  name: 'm-dialog',
  props: dialogProps,
  emits: ['ok', 'cancel', 'close'],
  setup: function setup(props, context) {
    // 增加锁住body的能力
    watch(function () {
      return props.visible;
    }, function (visible, pre) {
      if (visible === pre) {
        return;
      }

      var clazz = 'm-overflow-hidden';

      if (visible) {
        lockScrollCount++;

        if (lockScrollCount) {
          if (!document.body.classList.contains(clazz)) {
            document.body.classList.add(clazz);
          }
        }
      } else {
        lockScrollCount--;

        if (!lockScrollCount) {
          if (document.body.classList.contains(clazz)) {
            document.body.classList.remove(clazz);
          }
        }
      }
    }, {
      immediate: true
    });
    return function () {
      var locales = Config.getLocale();
      var title;

      if (props.title) {
        title = h("div", {
          "class": "m-dialog__title"
        }, [props.title]);
      } else if (context.slots.title) {
        title = context.slots.title();
      }

      var content;

      if (props.content) {
        content = h("div", {
          "class": "m-dialog__content ".concat(title ? '' : 'content_only')
        }, [props.content]);
      } else if (context.slots.content) {
        content = context.slots.content();
      }

      return h("div", [h("transition", {
        "attrs": {
          "name": "m-ani-fade",
          "appear": true
        }
      }, [props.visible && props.mask && h("div", {
        "class": "m-mask ".concat(props.maskClass),
        "on": {
          "click": function click() {
            return props.maskClosable && context.emit('close');
          }
        }
      })]), h("transition", {
        "attrs": {
          "name": "m-ani-fade",
          "appear": true
        }
      }, [props.visible && h("div", {
        "class": "m-dialog ".concat(props.dialogClass, " ").concat(props.showClose ? 'closable' : '')
      }, [props.showClose && h("div", {
        "class": "m-dialog__close"
      }, [h(CloseV1Outlined, {
        "on": {
          "click": function click() {
            return context.emit('close');
          }
        }
      })]), title, content, (props.showOk || props.showCancel) && h("div", {
        "class": "m-dialog__btns ".concat(props.buttonDirection)
      }, [props.showCancel && h(Button, {
        "props": _objectSpread2({}, props.cancelButtonProps),
        "on": {
          "click": function click() {
            return context.emit('cancel');
          }
        }
      }, [props.cancelText || locales.Dialog.cancelText]), props.showOk && props.showCancel && props.buttonDirection === 'horizontal' && h("div", {
        "class": "padding"
      }), props.showOk && h(Button, {
        "props": _objectSpread2({}, props.okButtonProps),
        "on": {
          "click": function click() {
            return context.emit('ok');
          }
        }
      }, [props.okText || locales.Dialog.okText])])])])]);
    };
  }
});
withInstall(Dialog);

export { Dialog as default };
//# sourceMappingURL=dialog.js.map
